export default __webpack_public_path__ + "static/media/163.4b631883.svg";